import React from "react";
import { Link } from "react-router-dom";
import { Flame, AlertCircle } from "lucide-react";
import { CategoryPill, ReadingMeta } from "./ArticleCard";

export function BreakingFlash({ articles = [] }) {
  const items = articles.slice(0, 4);
  if (!items.length) return null;
  return (
    <section className="my-16" data-testid="breaking-section">
      <SectionHead title="ब्रेकिंग न्यूज" icon={<AlertCircle className="h-5 w-5" />} accent="red" />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {items.map((a, i) => (
          <Link
            key={a.id}
            to={`/article/${a.slug}`}
            data-testid={`breaking-card-${a.id}`}
            className="bodh-card relative rounded-2xl border-l-4 border-[#E30613] bg-gradient-to-br from-red-50/70 to-white p-5 group hover:shadow-lg"
          >
            <div className="flex items-center gap-2 text-[10px] font-outfit font-black uppercase tracking-widest text-[#E30613]">
              <span className="h-1.5 w-1.5 rounded-full bg-[#E30613] bodh-pulse" /> Flash
            </div>
            <h3 className="mt-2 font-devanagari font-bold text-base leading-snug line-clamp-4 group-hover:text-[#E30613]">{a.title}</h3>
            <div className="mt-3"><ReadingMeta time={a.reading_time} dt={a.created_at} /></div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export function SectionHead({ title, subtitle, icon, accent = "red", action }) {
  return (
    <div className="flex items-end justify-between mb-6">
      <div>
        <div className="flex items-center gap-2 text-[#E30613] font-outfit font-black uppercase tracking-widest text-xs">
          {icon} <span>{accent === "yellow" ? "Highlight" : "Now"}</span>
        </div>
        <h2 className="mt-1 font-devanagari font-black text-2xl sm:text-3xl lg:text-4xl text-zinc-900 leading-tight">
          {title}
        </h2>
        {subtitle && <p className="mt-1 text-sm text-zinc-500 font-hind">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
